const closeButtonLabel = "Close";
const enIE = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  enIE as default
};
